import * as React from "react";
import { createBrowserHistory } from "history";
import { Link } from "react-router-dom";
import BPSidebar from "./BPSidebar";
import { GetOUList } from "../../../../actions/OUActions";
import OUStore from "../../../../stores/OUStore";
import { ExportBusinessProcess, GetBP, GetBPList, UpdateBP } from "../../../../actions/BPActions";
import BPStore from "../../../../stores/BPStore";
import actionTypes from "../../../../actions/ActionTypes";
const customHistory = createBrowserHistory();
class BusinessProcessView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentBP: {
        bpId: 0,
        bpName: "",
        workflowId: 0,
        formTypeId: 0
      },
      orgUnits: [],
      isDirty: false
    };
    this.onChangeBPName = this.onChangeBPName.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.onBPUpdate = this.onBPUpdate.bind(this);
    this.loadBPFromDB = this.loadBPFromDB.bind(this);
    this.onOUUpdate = this.onOUUpdate.bind(this);
    this.changeOU = this.changeOU.bind(this);
    this.onExportClick = this.onExportClick.bind(this);
  }
  componentDidMount() {
    BPStore.addChangeListener(this.onBPUpdate);
    OUStore.addChangeListener(this.onOUUpdate);
    this.loadBPFromDB();
    GetOUList();
  }
  componentWillUnmount() {
    BPStore.removeChangeListener(this.onBPUpdate);
    OUStore.removeChangeListener(this.onOUUpdate);
  }
  componentDidUpdate() {
    this.loadBPFromDB();
  }
  onBPUpdate() {
    let lastChange = BPStore.getLastChange();
    if (lastChange === actionTypes.BPUpdate) {
      let bp = BPStore.getCurrentBP();
      if (this.state.currentBP.bpId === 0 && bp.bpId !== 0) {
        customHistory.push(`/Admin/BusinessProcess/${bp.bpId}`);
        this.setState({ currentBP: bp, isDirty: false });
        GetBPList();
      } else {
        console.log(bp);
        this.setState({ currentBP: bp, isDirty: false });
        GetBPList();
      }
    }
    if (lastChange === actionTypes.BPGetOne) {
      let bp = BPStore.getCurrentBP();
      this.setState({ currentBP: bp, isDirty: false });
    }
  }
  onOUUpdate() {
    let lastChange = OUStore.getLastChange();
    if (lastChange === actionTypes.OUGetList) {
      let ous = OUStore.getOUList();
      this.setState({ orgUnits: ous });
    }
  }
  onSaveClick() {
    UpdateBP(
      this.state.currentBP.bpId,
      this.state.currentBP.bpName,
      this.state.currentBP.orgUnitId
    );
  }
  onExportClick() {
    ExportBusinessProcess(
      this.state.currentBP.bpId,
      this.state.currentBP.bpName
    );
  }
  loadBPFromDB() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let bpId = parseInt(pathParts[pathParts.length - 1], 10);
    if (this.state.currentBP.bpId !== 0 && bpId === 0) {
      let newBP = {
        bpId: 0,
        bpName: ""
      };
      this.setState({ currentBP: newBP, isDirty: false }, () => {
        document.getElementById("txtBPName").focus();
      });
    } else if (this.state.currentBP.bpId !== bpId) {
      GetBP(bpId);
    }
  }
  onChangeBPName(e) {
    let bp = this.state.currentBP;
    bp.bpName = e.target.value;
    this.setState({ currentBP: bp, isDirty: true });
  }
  changeOU(e) {
    let bp = this.state.currentBP;
    bp.orgUnitId = parseInt(e.target.value);
    this.setState({ currentBP: bp, isDirty: true });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "sidebarLayout d-flex flex-row flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "sidebar-container" }, /* @__PURE__ */ React.createElement(BPSidebar, null)), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: {
          display: "grid",
          gridTemplateColumns: "650px 1fr",
          gridTemplateRows: "180px 60px 1fr 15px",
          paddingLeft: "60px"
        }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "ouInfo",
          className: "card",
          style: { gridColumn: "1", gridRow: "1", margin: "16px" }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-folder" }), " Business Process"),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtOUName" }, "Name:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: `form-control`,
            id: "txtBPName",
            value: this.state.currentBP.bpName,
            onChange: this.onChangeBPName,
            placeholder: "business process name"
          }
        )), this.state.currentBP.bpId !== 0 && /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "selectOU" }, "Organizational Unit:"), /* @__PURE__ */ React.createElement(
          "select",
          {
            type: "text",
            className: `form-select`,
            id: "selectOU",
            value: this.state.currentBP.orgUnitId,
            onChange: this.changeOU,
            placeholder: "organizational unit (optional)"
          },
          /* @__PURE__ */ React.createElement("option", { value: "0" }, "none"),
          this.state.orgUnits.map((org) => /* @__PURE__ */ React.createElement("option", { key: org.orgUnitId, value: org.orgUnitId }, org.name))
        ))))
      ),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "bpButtons",
          style: { gridColumn: "1", gridRow: "2", marginLeft: "18px" }
        },
        /* @__PURE__ */ React.createElement("button", { className: "btn btn-secondary", onClick: this.onExportClick }, "Export Business Process"),
        this.state.isDirty && this.state.currentBP.bpName.trim() !== "" && /* @__PURE__ */ React.createElement("button", { className: "btn btn-success", onClick: this.onSaveClick }, "Save changes")
      ),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "wfandFt",
          style: { gridColumn: "1", gridRow: "3", marginLeft: "18px" }
        },
        this.state.currentBP.bpId !== 0 && /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement(
          Link,
          {
            to: `/Admin/WorkflowView/${this.state.currentBP.workflowId}`
          },
          /* @__PURE__ */ React.createElement(
            "button",
            {
              style: {
                width: "250px",
                height: "150px",
                backgroundColor: "#BADDFF",
                border: "solid 1px #4D87BF"
              },
              className: "btn"
            },
            /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-sitemap", size: "2x" })),
            /* @__PURE__ */ React.createElement("span", { style: { fontWeight: "700" } }, "View Workflow")
          )
        )), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement(
          Link,
          {
            to: `/Admin/FormType/${this.state.currentBP.formTypeId}`
          },
          /* @__PURE__ */ React.createElement(
            "button",
            {
              style: {
                width: "250px",
                height: "150px",
                backgroundColor: "#D4FFBA",
                border: "solid 1px #5FB02F"
              },
              className: "btn"
            },
            /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-file-alt", size: "2x" })),
            /* @__PURE__ */ React.createElement("span", { style: { fontWeight: "700" } }, "View Form Type")
          )
        )))
      )
    ));
  }
}
export default BusinessProcessView;
